import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SiteStateService } from '@core/services/site-state/site-state.service';
import { ImpactOverlayRef } from '@libs/overlay';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { transform } from '@shared/animations/animations.functions';
import { TranslateSafePipe } from '../../../@shared/translate-safe/translate-safe.pipe';
import { SvgIconComponent } from '../../../@shared/svg-icon/svg-icon.component';

@UntilDestroy()
@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        transform({ trigger: 'dialogReveal', property: 'translateY', valueFrom: '50px', valueTo: '0', fadeIn: true })
    ],
    imports: [SvgIconComponent, TranslateSafePipe]
})
export class DialogComponent implements AfterViewInit, OnInit {
    @ViewChild('dialog')
    private readonly dialog: ElementRef<HTMLElement>;

    constructor(private overlayRef: ImpactOverlayRef, private readonly siteStateService: SiteStateService) {
        overlayRef
            .beforeClose()
            .pipe(untilDestroyed(this))
            .subscribe(() => {
                this.siteStateService.setState('dialog', false);
            });
    }

    close(): void {
        this.overlayRef.close();
    }

    ngOnInit(): void {
        this.siteStateService.setState('dialog', true);
    }

    ngAfterViewInit(): void {
        this.dialog.nativeElement.focus();
    }
}
